// DİKKAT: import React from "react" KULLANMIYORUZ!
const React = window.EcommerceCore.vendors.React;
const ReactSelect =
  window.EcommerceCore.vendors.ReactSelect.default ||
  window.EcommerceCore.vendors.ReactSelect;
const Icon = window.EcommerceCore.common.components.Icon;

export const MtcCascadingAttributes = ({
  product,
  selectedAttributes,
  availableTermsPerAttribute,
  onAttributeSelect,
  onClear,
}: any) => {
  const attributes = product.enrichedAttributes.filter(
    (attr: any) => attr.hasVariations,
  );
  if (attributes.length === 0) return null;

  const hasSelection = Object.keys(selectedAttributes).length > 0;

  // Özel stiller (SCSS ile uğraşmadan direct objeler üzerinden minimal müdahale)
  // React-select'in gri kutu görünümünü sağlamak için
  const customStyles = {
    control: (base: any) => ({
      ...base,
      backgroundColor: "#f8f9fa",
      borderColor: "#e2e8f0",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#cbd5e1",
      },
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#1a74e5" : base.backgroundColor,
      "&:hover": {
        backgroundColor: state.isSelected ? "#1a74e5" : "#f1f5f9",
      },
    }),
  };

  return (
    <div className="mtc-attributes-table">
      {attributes.map((attr: any) => {
        const availableSlugs = availableTermsPerAttribute[attr.taxonomy] || [];

        const options = attr.terms
          .filter((term: any) => availableSlugs.includes(term.slug))
          .map((term: any) => ({
            value: term.slug,
            label: term.name,
          }));

        const selectedOption =
          options.find(
            (opt: any) => opt.value === selectedAttributes[attr.taxonomy],
          ) || null;

        return (
          <div key={attr.id} className="mtc-attribute-row">
            <div className="mtc-attribute-label">{attr.name}</div>
            <div className="mtc-attribute-select">
              <ReactSelect
                options={options}
                value={selectedOption}
                onChange={(option: any) =>
                  onAttributeSelect(attr.taxonomy, option?.value)
                }
                placeholder="Seçiniz..."
                className="mtc-react-select-container"
                classNamePrefix="mtc-react-select"
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
        );
      })}

      {hasSelection && (
        <div className="mtc-attribute-row mtc-attribute-row--clear">
          <div className="mtc-attribute-label"></div>
          <div className="mtc-attribute-select">
            <button
              className="mtc-clear-btn"
              onClick={onClear}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                background: "none",
                border: "none",
                color: "#64748b",
                cursor: "pointer",
                padding: "10px 0",
              }}
            >
              <Icon iconName="x-mark" /> Temizle
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
